var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("TopHead", {
        attrs: { "top-type": "black", title: _vm.spver === 1 ? "" : "播单" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bd-top" }, [
        _c("figure", { staticClass: "bd-info-box" }, [
          _c("figcaption", [_vm._v(_vm._s(_vm.playListData.title))]),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "bd-info-tag" },
            [
              _vm._l(_vm.tags, function (v, index) {
                return [
                  _c("span", { key: index }, [_vm._v(_vm._s(v))]),
                  _vm._v(" "),
                  index !== _vm.tags.length - 1 && _vm.tags.length > 1
                    ? _c("em", { key: index }, [_vm._v("/")])
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.playListData.quantity && _vm.playListData.quantity > 0
            ? _c("p", { staticClass: "bd-info-num" }, [
                _vm._v(
                  "\n        共 " +
                    _vm._s(_vm.playListData.quantity) +
                    " 部作品\n      "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.playListData.introduction
          ? _c("div", { staticClass: "bd-info-text" }, [
              _c(
                "div",
                {
                  class: [
                    "bd-info-detail",
                    { clip: _vm.fold },
                    { fix: _vm.fix },
                  ],
                },
                [
                  _c("p", { staticClass: "fake-content" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.playListData.introduction) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "bd-info-detail-intro" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.playListData.introduction) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.clip
                    ? _c(
                        "div",
                        {
                          staticClass: "bd-info-detail-more",
                          on: { click: _vm.unfoldIntro },
                        },
                        [_c("span", [_vm._v("展开")]), _vm._v(" "), _c("i")]
                      )
                    : _vm._e(),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("Info", {
        attrs: { "bodan-list": _vm.playListData.bodan_list || [] },
      }),
      _vm._v(" "),
      _c("RelatedPlayList", {
        attrs: { "initial-data": _vm.playListData.relatedInfo },
      }),
      _vm._v(" "),
      _c("Gotop"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }